import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=ecee1da6&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=ts&"
export * from "./Confirm.vue?vue&type=script&lang=ts&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=ecee1da6&lang=less&scoped=true&"
import style1 from "./Confirm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee1da6",
  null
  
)

export default component.exports